import { DEFINITIONS as LINK_DEFINITIONS } from '@xingternal/content-editor-plugin-link';

import { LINK_TYPENAME, SERIALIZATION } from '../constants';

const DEFINITIONS = {
  type: LINK_DEFINITIONS.type,
  __typename: LINK_TYPENAME,
};

const linkMarkSerializer = ({ node, matchMark, createMark, direction }) => {
  if (
    matchMark({
      node,
      match: DEFINITIONS,
    })
  ) {
    if (direction === SERIALIZATION) {
      let { start, end, data = {} } = node;
      if (start === end) return;
      return createMark({
        node: { start, end },
        definitions: DEFINITIONS,
        data,
      });
    }
    let { __typename, start, end, text, ...data } = node;
    return createMark({
      node,
      definitions: DEFINITIONS,
      data,
    });
  }
};

export { linkMarkSerializer };
